import React from 'react';

// Outline line-icon glyphs for each VectorName. 16×16, currentColor stroke.
// Used in VectorRow / EncouragementMeter / Vault facial-feedback panel.
// DESIGN.md §6.1 — outlined line icons, never icon-in-colored-circle.

const Glyph = ({ children }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    {children}
  </svg>
);

export const VectorGlyphs = {
  skin: (
    <Glyph>
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.2" />
      <circle cx="6" cy="6" r="0.5" fill="currentColor" />
      <circle cx="10" cy="9" r="0.5" fill="currentColor" />
      <circle cx="7.5" cy="11" r="0.5" fill="currentColor" />
    </Glyph>
  ),
  jaw: (
    <Glyph>
      <path d="M3 5 C3 9 5 13 8 13 C11 13 13 9 13 5" stroke="currentColor" strokeWidth="1.2" />
    </Glyph>
  ),
  brows: (
    <Glyph>
      <path d="M2 7 Q5 5 8 6 M8 6 Q11 5 14 7" stroke="currentColor" strokeWidth="1.2" />
    </Glyph>
  ),
  eyes: (
    <Glyph>
      <path d="M2 8 Q5 4 8 4 Q11 4 14 8 Q11 12 8 12 Q5 12 2 8 Z" stroke="currentColor" strokeWidth="1.2" />
      <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.2" />
    </Glyph>
  ),
  hair: (
    <Glyph>
      <path d="M3 5 C3 3 5 2 8 2 C11 2 13 3 13 5 L13 9 M3 5 L3 9 M3 9 Q5 7 8 8 Q11 7 13 9" stroke="currentColor" strokeWidth="1.2" />
    </Glyph>
  ),
  lips: (
    <Glyph>
      <path d="M2 9 Q4 7 8 7 Q12 7 14 9 Q12 11 8 11 Q4 11 2 9 Z M8 7 L8 8" stroke="currentColor" strokeWidth="1.2" />
    </Glyph>
  ),
  harmony: (
    <Glyph>
      <path d="M8 2 L8 14 M4 4 L12 12 M4 12 L12 4" stroke="currentColor" strokeWidth="1.2" />
    </Glyph>
  ),
  skin_tone: (
    <Glyph>
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.2" />
      <path d="M3 8 L13 8" stroke="currentColor" strokeWidth="1.2" />
    </Glyph>
  ),
};

// ── Glowup / feedback taxonomy category glyphs ──────────────────────────────
// Distinct 16×16 outline glyphs for the 6 modifiable categories glowup judges.
// First-class keys (not legacy aliases) so each reads clearly for its category.
// Legacy keys above are retained to render frozen old scans.
VectorGlyphs.skin_quality = (
  <Glyph>
    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="6" cy="6.5" r="0.55" fill="currentColor" />
    <circle cx="10.2" cy="7.4" r="0.55" fill="currentColor" />
    <circle cx="7.6" cy="10.4" r="0.55" fill="currentColor" />
  </Glyph>
);
VectorGlyphs.hair_scalp = (
  <Glyph>
    <path d="M3 9.5 C3 4.5 5.2 2.5 8 2.5 C10.8 2.5 13 4.5 13 9.5" stroke="currentColor" strokeWidth="1.2" />
    <path d="M4.6 6 Q8 3.4 11.4 6" stroke="currentColor" strokeWidth="1.2" />
    <path d="M3 9.5 L3 12.5 M13 9.5 L13 12.5" stroke="currentColor" strokeWidth="1.2" />
  </Glyph>
);
VectorGlyphs.facial_hair = (
  <Glyph>
    <path d="M4 4.5 L4 7 C4 10 6 12.5 8 12.5 C10 12.5 12 10 12 7 L12 4.5" stroke="currentColor" strokeWidth="1.2" />
    <path d="M6 6.6 L6 8.6 M8 7 L8 9.4 M10 6.6 L10 8.6" stroke="currentColor" strokeWidth="1.2" />
  </Glyph>
);
VectorGlyphs.brows_lashes = (
  <Glyph>
    <path d="M2.5 6.5 Q5.5 4.4 8.6 5.6" stroke="currentColor" strokeWidth="1.2" />
    <path d="M3 8.6 L3 10.1 M5 8.9 L5 10.4 M7 8.9 L7 10.4 M9 8.7 L9 10.2" stroke="currentColor" strokeWidth="1.2" />
  </Glyph>
);
VectorGlyphs.mouth_smile = (
  <Glyph>
    <path d="M3 7.4 Q8 12.6 13 7.4" stroke="currentColor" strokeWidth="1.2" />
    <path d="M5 8.2 Q8 10.6 11 8.2" stroke="currentColor" strokeWidth="1.2" />
  </Glyph>
);
VectorGlyphs.definition = (
  <Glyph>
    <path d="M3.5 3.8 L3.5 6.6 L8 12.6 L12.5 6.6 L12.5 3.8" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
  </Glyph>
);

// Returns a glyph for any vector key, with safe fallback.
export function vectorGlyph(name) {
  return VectorGlyphs[name] || VectorGlyphs.harmony;
}

export default VectorGlyphs;
